// Generated file : do not modify
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Gestion des items du wizard
export default class WizardItem  {
  // Identifiant unique
  public id: number;
  // Id Wizard
  public wizardId: number;
  // Label de l'étape courante
  public label: string;
  // Titre l'étape courante
  public title: string;
  // Picto l'étape courante
  public picto: string;
  // Id de la descri
  public descriptionHtmlId: number;
  // description l'étape courante
  public description: string;
  // Ordre des items
  public position: number;
  // Titre l'étape courante
  public titleHtmlId: number;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.wizardId = 0;
    this.label = '';
    this.title = '';
    this.picto = '';
    this.descriptionHtmlId = 0;
    this.description = '';
    this.position = 0;
    this.titleHtmlId = 0;
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: WizardItem): WizardItem {
    const newWizardItem: WizardItem = new WizardItem();
    newWizardItem.id = obj.id;
    newWizardItem.wizardId = obj.wizardId;
    newWizardItem.label = obj.label;
    newWizardItem.title = obj.title;
    newWizardItem.picto = obj.picto;
    newWizardItem.descriptionHtmlId = obj.descriptionHtmlId;
    newWizardItem.description = obj.description;
    newWizardItem.position = obj.position;
    newWizardItem.titleHtmlId = obj.titleHtmlId;
    newWizardItem.createId = obj.createId;
    newWizardItem.failed = obj.failed;
    newWizardItem.canUpdate = obj.canUpdate;
    newWizardItem.canDelete = obj.canDelete;
    newWizardItem.display = obj.display;
    newWizardItem.notifDefType = obj.notifDefType;
    return newWizardItem;
  }

  public toJsonWizardItem (): string {
    const json = {
      wizardId: this.wizardId,
      label: this.label,
      title: this.title,
      picto: this.picto,
      descriptionHtmlId: this.descriptionHtmlId,
      description: this.description,
      position: this.position,
      titleHtmlId: this.titleHtmlId,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromWizardItem (obj: WizardItem): void {
    this.id = obj.id;
    this.wizardId = obj.wizardId;
    this.label = obj.label;
    this.title = obj.title;
    this.picto = obj.picto;
    this.descriptionHtmlId = obj.descriptionHtmlId;
    this.description = obj.description;
    this.position = obj.position;
    this.titleHtmlId = obj.titleHtmlId;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareWizardItem (value: WizardItem): boolean {
    return (this.toJsonWizardItem() == value.toJsonWizardItem());
  }

  public cloneWizardItem (): WizardItem {
    return WizardItem.fromJson(this);
  }

  public createForStoreWizardItem (): Promise<WizardItem> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/wizarditems/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromWizardItem(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreWizardItem (): Promise<WizardItem> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/wizarditems/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromWizardItem(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreWizardItem (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/wizarditems/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/wizarditems/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/WizardItems/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = WizardItem.fromJson(listData.reccords[0] as WizardItem);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<WizardItem> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/WizardItems/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = WizardItem.fromJson(listData.reccords[0] as WizardItem);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(wizardItems: WizardItem[]) {
  }
}
